import { CardMedia } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const CardImage = styled(CardMedia)(({ grey }) => ({
  filter: grey ? "grayscale(100%)" : "",
  height: 277,
}));

export default CardImage;
